import {lookupShift} from 'constants/url';
import axios from 'axios';

async function getAllShifts(token) {
  try {
    const response = await axios.get(`${lookupShift}`, {
      headers: {Authorization: `Bearer ${token}`},
    });
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

export default getAllShifts;
